module.exports = __webpack_public_path__ + "static/img/nini_wu_cert.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wmm/nini_wu_cert.jpg
// module id = EgjW
// module chunks = 0